/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%] {\n  display: block; }\n\n.td-search-box[_ngcontent-%COMP%]   td-search-input[_ngcontent-%COMP%] {\n  margin-left: 12px; }\n    [dir=\'rtl\'] .td-search-box td-search-input {\n    margin-right: 12px;\n    margin-left: 0px !important; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9ub2RlX21vZHVsZXMvQGNvdmFsZW50L2NvcmUvc2VhcmNoL3NlYXJjaC1ib3gvc2VhcmNoLWJveC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL29yaW9uL1Byb2plY3RzL3NpbXBsaWNpdHlFbmdpbmUvdmFsbXVzdC92YWxtdXN0ZmUvbm9kZV9tb2R1bGVzL0Bjb3ZhbGVudC9jb3JlL3NlYXJjaC9zZWFyY2gtYm94L3NlYXJjaC1ib3guY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/search/search-box/search-box.component.css.shim.ngstyle.ts